var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"videoContainer",staticClass:"dui-video"},[_c('div',{staticClass:"youtube-video",attrs:{"id":("youtube-video-" + _vm._uid)}})])}
var staticRenderFns = []

export { render, staticRenderFns }